
import React from "react";
import "./storagebanner.scss";
import { Link } from "react-router-dom";

const Storagebanner = () => {
  return (
    <>
      <section className="bannermainprntstorage">
        <div className="storagbannerpostionimg">
          <img src="\assets\Storageimages\storagbannerpostionimg.png" alt="img" className="img-fluid" />
        </div>
        <div className="custom-container ">
          {/* <div className="headerstorage">
            <div className="headerstoragenav">
              <Link to="/"><img className="img-fluid" src="\assets\Storageimages\storagelogo.svg" alt="logo" /></Link>
              <button className="teritybtn">Try it now</button>
            </div>
          </div> */}
          <div className="heromain">
            <div className="heroleftseaction">
              <div className="textherobanner">
                <h1>Your Data,
                  Your Control</h1>
                <p>Secure, private, and censorship-resistant storage is now live</p>
              </div>
              <a href="https://storage.tomi.com/?_gl=1*zk4lc2*_gcl_au*MjA4ODQwNTQ5OC4xNzQxMDI3OTEw" target="_blank">
                <button className="herofeaturebannerbtn primerybtn">
                  Start Using Storage
                </button>
              </a>
            </div>
            <div className="herorightseaction">
              <img className="img-fluid" src="\assets\Storageimages\storagebannerimgs.png" alt="img" />
            </div>
          </div>
        </div>
      </section >
    </>
  );
};

export default Storagebanner;
